export const MOBILE_55_VIDEO_ID = 'c8hnrfwfum';
export const DESKTOP_VIDEO_ID = '33mcd0ey28';
export const APP_DOWNLOAD_LINK_APP_PAGE = 'https://goat.app.link/VqCX9RvpVbb';
export const BG_IMG_LG = 'https://cms-cdn.goat.com/e2962cd030b4-5298-de11-bee5-047b6343.jpg';
export const HERO_IMG_LG = 'https://cms-cdn.goat.com/cf9870c8a276-8c8b-de11-aee5-090feb9b.jpg';
export const HERO_IMG_SM = 'https://cms-cdn.goat.com/e2962cd030b4-5298-de11-aee5-09a64a8c.jpg';
export const QR_CODE = 'https://cms-cdn.goat.com/b828f3d8e61d-e49a-de11-10f5-06c1b8d0.png';
